var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a2, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a2, prop, b[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b) => __defProps(a2, __getOwnPropDescs(b));
import { defineComponent, h, computed, ref, watch, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, withDirectives, withKeys, vModelText, renderSlot, Fragment, renderList, createBlock, mergeProps, createCommentVNode } from "vue";
const s = (e) => e.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&"), a = (e, i) => {
  if (!i.query || i.query instanceof String && !i.query.trim())
    return e;
  const r = ((e2) => {
    let t;
    if (e2.query instanceof RegExp)
      return new RegExp(String.raw`(${e2.query.source})`, "g" + (e2.caseSensitive ? "" : "i"));
    if (e2.splitBySpace) {
      const i2 = e2.query.trim().replace(/\s+/g, " ");
      t = String.raw`(${i2.split(/\s/).map(s).join("|")})`;
    } else
      t = String.raw`(${s(e2.query)})`;
    return new RegExp(String.raw`${t}`, "g" + (e2.caseSensitive ? "" : "i"));
  })({ query: i.query, splitBySpace: i.splitBySpace, caseSensitive: i.caseSensitive });
  return e.split(r).map((e2) => r.test(e2) ? h(i.highlightTag, { class: i.highlightClass, style: i.highlightStyle }, e2) : e2);
};
var l = defineComponent({ name: "VueWordHighlighter", props: { query: { type: [String, Object], required: true, default: "" }, caseSensitive: { type: Boolean, default: false }, splitBySpace: { type: Boolean, default: false }, highlightClass: { type: [Object, String, Array], default: "" }, highlightStyle: { type: [Object, String, Array], default: "" }, highlightTag: { type: String, default: "mark" }, wrapperTag: { type: String, default: "span" }, wrapperClass: { type: [Object, String, Array], default: "" }, textToHighlight: { type: String, default: "" } }, emits: ["matches"], setup: (i, r) => () => {
  const s2 = i.textToHighlight ? i.textToHighlight : ((t) => {
    if (t && t.default) {
      const i2 = t.default();
      let r2;
      return r2 = i2[0].children, typeof r2 == "string" ? r2 : "";
    }
    return "";
  })(r.slots), l2 = a(s2, { query: i.query, splitBySpace: i.splitBySpace, caseSensitive: i.caseSensitive, highlightTag: i.highlightTag, highlightClass: i.highlightClass, highlightStyle: i.highlightStyle });
  var g;
  return r.emit("matches", typeof (g = l2) == "string" ? [] : g.filter((e) => typeof e != "string").map((t) => typeof t == "string" ? t : t.children)), h(i.wrapperTag, { class: i.wrapperClass }, l2);
} });
var KeyEvent = /* @__PURE__ */ ((KeyEvent2) => {
  KeyEvent2["Enter"] = "enter";
  KeyEvent2["Esc"] = "esc";
  KeyEvent2["Up"] = "up";
  KeyEvent2["Down"] = "down";
  return KeyEvent2;
})(KeyEvent || {});
const BOUNDS = {
  COUNTRY: "country",
  REGION: "region",
  AREA: "area",
  CITY: "city",
  SETTLEMENT: "settlement",
  STREET: "street",
  HOUSE: "house",
  FLAT: "flat"
};
const DEFAULT_CLASSES = {
  container: "vue-dadata",
  search: "vue-dadata__search",
  input: "vue-dadata__input",
  suggestions: "vue-dadata__suggestions",
  suggestionItem: "vue-dadata__suggestions-item",
  suggestionCurrentItem: "vue-dadata__suggestions-item_current"
};
const DEFAULT_HIGHLIGHT_OPTIONS = {
  caseSensitive: false,
  splitBySpace: false,
  highlightTag: "mark",
  highlightClass: "vue-dadata__suggestion-item-text_highlight",
  highlightStyle: "",
  wrapperTag: "span",
  wrapperClass: ""
};
const useClasses = (classes) => computed(() => {
  var _a, _b, _c, _d, _e, _f;
  return {
    container: (_a = classes == null ? void 0 : classes.container) != null ? _a : DEFAULT_CLASSES.container,
    search: (_b = classes == null ? void 0 : classes.search) != null ? _b : DEFAULT_CLASSES.search,
    input: (_c = classes == null ? void 0 : classes.input) != null ? _c : DEFAULT_CLASSES.input,
    suggestions: (_d = classes == null ? void 0 : classes.suggestions) != null ? _d : DEFAULT_CLASSES.suggestions,
    suggestionItem: (_e = classes == null ? void 0 : classes.suggestionItem) != null ? _e : DEFAULT_CLASSES.suggestionItem,
    suggestionCurrentItem: (_f = classes == null ? void 0 : classes.suggestionCurrentItem) != null ? _f : DEFAULT_CLASSES.suggestionCurrentItem
  };
});
const useHighlightOptions = (highlightOptions) => computed(() => {
  var _a, _b, _c, _d, _e, _f, _g;
  return {
    caseSensitive: (_a = highlightOptions == null ? void 0 : highlightOptions.caseSensitive) != null ? _a : DEFAULT_HIGHLIGHT_OPTIONS.caseSensitive,
    splitBySpace: (_b = highlightOptions == null ? void 0 : highlightOptions.splitBySpace) != null ? _b : DEFAULT_HIGHLIGHT_OPTIONS.splitBySpace,
    highlightTag: (_c = highlightOptions == null ? void 0 : highlightOptions.highlightTag) != null ? _c : DEFAULT_HIGHLIGHT_OPTIONS.highlightTag,
    highlightClass: (_d = highlightOptions == null ? void 0 : highlightOptions.highlightClass) != null ? _d : DEFAULT_HIGHLIGHT_OPTIONS.highlightClass,
    highlightStyle: (_e = highlightOptions == null ? void 0 : highlightOptions.highlightStyle) != null ? _e : DEFAULT_HIGHLIGHT_OPTIONS.highlightStyle,
    wrapperTag: (_f = highlightOptions == null ? void 0 : highlightOptions.wrapperTag) != null ? _f : DEFAULT_HIGHLIGHT_OPTIONS.wrapperTag,
    wrapperClass: (_g = highlightOptions == null ? void 0 : highlightOptions.wrapperClass) != null ? _g : DEFAULT_HIGHLIGHT_OPTIONS.wrapperClass
  };
});
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var vueDebounce_min = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    t(exports);
  }(commonjsGlobal, function(e) {
    function t(e2, t2) {
      return function(e3) {
        if (Array.isArray(e3))
          return e3;
      }(e2) || function(e3, t3) {
        var n2 = e3 == null ? null : typeof Symbol != "undefined" && e3[Symbol.iterator] || e3["@@iterator"];
        if (n2 == null)
          return;
        var r2, o2, i2 = [], a3 = true, u2 = false;
        try {
          for (n2 = n2.call(e3); !(a3 = (r2 = n2.next()).done) && (i2.push(r2.value), !t3 || i2.length !== t3); a3 = true)
            ;
        } catch (e4) {
          u2 = true, o2 = e4;
        } finally {
          try {
            a3 || n2.return == null || n2.return();
          } finally {
            if (u2)
              throw o2;
          }
        }
        return i2;
      }(e2, t2) || function(e3, t3) {
        if (!e3)
          return;
        if (typeof e3 == "string")
          return n(e3, t3);
        var r2 = Object.prototype.toString.call(e3).slice(8, -1);
        r2 === "Object" && e3.constructor && (r2 = e3.constructor.name);
        if (r2 === "Map" || r2 === "Set")
          return Array.from(e3);
        if (r2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r2))
          return n(e3, t3);
      }(e2, t2) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function n(e2, t2) {
      (t2 == null || t2 > e2.length) && (t2 = e2.length);
      for (var n2 = 0, r2 = new Array(t2); n2 < t2; n2++)
        r2[n2] = e2[n2];
      return r2;
    }
    function r(e2, n2) {
      var r2, o2, i2, a3, u2 = null, l3 = typeof n2 == "number" ? n2 : (r2 = t(String(n2).split(/(ms|s)/i), 2), o2 = r2[0], i2 = r2[1], a3 = i2 === void 0 ? "ms" : i2, Number(o2) * { ms: 1, s: 1e3 }[a3]), c2 = function() {
        for (var t2 = this, n3 = arguments.length, r3 = new Array(n3), o3 = 0; o3 < n3; o3++)
          r3[o3] = arguments[o3];
        var i3 = function() {
          u2 = null, e2.apply(t2, r3);
        };
        clearTimeout(u2), (u2 = setTimeout(i3, l3)) || e2.apply(this, r3);
      };
      return c2.cancel = function() {
        clearTimeout(u2), u2 = null;
      }, c2;
    }
    function o(e2) {
      return e2.map(function(e3) {
        return e3.toLowerCase();
      });
    }
    function i(e2, t2) {
      var n2, r2 = e2 ? e2["debounce-events"] : [];
      return r2 && r2.length > 0 ? Array.isArray(r2) ? o(r2) : o(r2.split(",")) : o((n2 = t2, Array.isArray(n2) ? n2 : n2 == null ? [] : [n2]));
    }
    function a2(e2) {
      return e2 === "";
    }
    function u(e2, t2) {
      return e2 === "Enter" && (!t2.lock || t2.unlock);
    }
    function l2(e2, t2, n2) {
      return a2(e2) && n2.fireonempty && (t2 === "Enter" || t2 === " ");
    }
    function c() {
      var e2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t2 = e2.lock, n2 = t2 !== void 0 && t2, o2 = e2.listenTo, c2 = o2 === void 0 ? "keyup" : o2, f2 = e2.defaultTime, v = f2 === void 0 ? "300ms" : f2, d = e2.fireOnEmpty, s2 = d !== void 0 && d, y = e2.cancelOnEmpty, m = y !== void 0 && y, p = e2.trim, g = p !== void 0 && p;
      return { bind: function(e3, t3, o3) {
        var f3 = t3.value, d2 = t3.arg, y2 = d2 === void 0 ? v : d2, p2 = t3.modifiers, b = Object.assign({ lock: n2, trim: g, fireonempty: s2, cancelonempty: m }, p2), h2 = i(o3.data.attrs, c2), k = r(function(e4) {
          f3(e4.target.value, e4);
        }, y2);
        function A(e4) {
          var t4 = b.trim ? e4.target.value.trim() : e4.target.value;
          a2(t4) && b.cancelonempty ? k.cancel() : u(e4.key, b) || l2(t4, e4.key, b) ? (k.cancel(), f3(e4.target.value, e4)) : k(e4);
        }
        h2.forEach(function(t4) {
          e3.addEventListener(t4, A);
        });
      } };
    }
    var f = { install: function(e2) {
      var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      e2.directive("debounce", c(t2));
    } };
    e.debounce = r, e.default = f, e.vue3Debounce = function() {
      var e2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t2 = e2.lock, n2 = t2 !== void 0 && t2, o2 = e2.listenTo, c2 = o2 === void 0 ? "keyup" : o2, f2 = e2.defaultTime, v = f2 === void 0 ? "300ms" : f2, d = e2.fireOnEmpty, s2 = d !== void 0 && d, y = e2.cancelOnEmpty, m = y !== void 0 && y, p = e2.trim, g = p !== void 0 && p;
      return { created: function(e3, t3, o3) {
        var f3 = t3.value, d2 = t3.arg, y2 = d2 === void 0 ? v : d2, p2 = t3.modifiers, b = Object.assign({ lock: n2, trim: g, fireonempty: s2, cancelonempty: m }, p2), h2 = i(o3.props, c2), k = r(function(e4) {
          f3(e4.target.value, e4);
        }, y2);
        function A(e4) {
          var t4 = b.trim ? e4.target.value.trim() : e4.target.value;
          a2(t4) && b.cancelonempty ? k.cancel() : u(e4.key, b) || l2(t4, e4.key, b) ? (k.cancel(), f3(e4.target.value, e4)) : k(e4);
        }
        h2.forEach(function(t4) {
          e3.addEventListener(t4, A);
        });
      } };
    }, Object.defineProperty(e, "__esModule", { value: true });
  });
})(vueDebounce_min, vueDebounce_min.exports);
var axios$2 = { exports: {} };
var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};
var bind$1 = bind$2;
var toString = Object.prototype.toString;
function isArray(val) {
  return Array.isArray(val);
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return toString.call(val) === "[object FormData]";
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
function isString(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (toString.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
  return toString.call(val) === "[object Date]";
}
function isFile(val) {
  return toString.call(val) === "[object File]";
}
function isBlob(val) {
  return toString.call(val) === "[object Blob]";
}
function isFunction(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return toString.call(val) === "[object URLSearchParams]";
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i = 0, l2 = obj.length; i < l2; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l2 = arguments.length; i < l2; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}
function extend(a2, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a2[key] = bind$1(val, thisArg);
    } else {
      a2[key] = val;
    }
  });
  return a2;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$e = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM
};
var utils$d = utils$e;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$d.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$d.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$d.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$d.forEach(val, function parseValue(v) {
        if (utils$d.isDate(v)) {
          v = v.toISOString();
        } else if (utils$d.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + "=" + encode(v));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$c = utils$e;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn) {
  utils$c.forEach(this.handlers, function forEachHandler(h2) {
    if (h2 !== null) {
      fn(h2);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$b = utils$e;
var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$b.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
var enhanceError$2 = function enhanceError(error, config, code, request2, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request2;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};
var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
var enhanceError$1 = enhanceError$2;
var createError$2 = function createError(message, config, code, request2, response) {
  var error = new Error(message);
  return enhanceError$1(error, config, code, request2, response);
};
var createError$1 = createError$2;
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};
var utils$a = utils$e;
var cookies$1 = utils$a.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + "=" + encodeURIComponent(value));
      if (utils$a.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$a.isString(path)) {
        cookie.push("path=" + path);
      }
      if (utils$a.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {
    },
    read: function read() {
      return null;
    },
    remove: function remove() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL2 = isAbsoluteURL$1;
var combineURLs2 = combineURLs$1;
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL2(requestedURL)) {
    return combineURLs2(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$9 = utils$e;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils$9.forEach(headers.split("\n"), function parser(line) {
    i = line.indexOf(":");
    key = utils$9.trim(line.substr(0, i)).toLowerCase();
    val = utils$9.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$8 = utils$e;
var isURLSameOrigin$1 = utils$8.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$8.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$3(message) {
  this.message = message;
}
Cancel$3.prototype.toString = function toString2() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$7 = utils$e;
var settle2 = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath2 = buildFullPath$1;
var parseHeaders2 = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError2 = createError$2;
var transitionalDefaults$1 = transitional;
var Cancel$2 = Cancel_1;
var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$7.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request2 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath2(config.baseURL, config.url);
    request2.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
    request2.timeout = config.timeout;
    function onloadend() {
      if (!request2) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
      var response = {
        data: responseData,
        status: request2.status,
        statusText: request2.statusText,
        headers: responseHeaders,
        config,
        request: request2
      };
      settle2(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request2 = null;
    }
    if ("onloadend" in request2) {
      request2.onloadend = onloadend;
    } else {
      request2.onreadystatechange = function handleLoad() {
        if (!request2 || request2.readyState !== 4) {
          return;
        }
        if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request2.onabort = function handleAbort() {
      if (!request2) {
        return;
      }
      reject(createError2("Request aborted", config, "ECONNABORTED", request2));
      request2 = null;
    };
    request2.onerror = function handleError() {
      reject(createError2("Network Error", config, null, request2));
      request2 = null;
    };
    request2.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional3 = config.transitional || transitionalDefaults$1;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError2(timeoutErrorMessage, config, transitional3.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request2));
      request2 = null;
    };
    if (utils$7.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request2) {
      utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request2.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$7.isUndefined(config.withCredentials)) {
      request2.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request2.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request2.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request2.upload) {
      request2.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken || config.signal) {
      onCanceled = function(cancel) {
        if (!request2) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
        request2.abort();
        request2 = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request2.send(requestData);
  });
};
var utils$6 = utils$e;
var normalizeHeaderName2 = normalizeHeaderName$1;
var enhanceError2 = enhanceError$2;
var transitionalDefaults = transitional;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$6.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$6.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: transitionalDefaults,
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");
    if (utils$6.isFormData(data2) || utils$6.isArrayBuffer(data2) || utils$6.isBuffer(data2) || utils$6.isStream(data2) || utils$6.isFile(data2) || utils$6.isBlob(data2)) {
      return data2;
    }
    if (utils$6.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$6.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$6.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional3 = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional3 && transitional3.silentJSONParsing;
    var forcedJSONParsing = transitional3 && transitional3.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$6.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw enhanceError2(e, this, "E_JSON_PARSE");
          }
          throw e;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$6.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});
utils$6.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$5 = utils$e;
var defaults$2 = defaults_1;
var transformData$1 = function transformData(data2, headers, fns) {
  var context = this || defaults$2;
  utils$5.forEach(fns, function transform(fn) {
    data2 = fn.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};
var utils$4 = utils$e;
var transformData2 = transformData$1;
var isCancel2 = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData2.call(config, config.data, config.headers, config.transformRequest);
  config.headers = utils$4.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$4.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData2.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel2(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData2.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};
var utils$3 = utils$e;
var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source2) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source2)) {
      return utils$3.merge(target, source2);
    } else if (utils$3.isPlainObject(source2)) {
      return utils$3.merge({}, source2);
    } else if (utils$3.isArray(source2)) {
      return source2.slice();
    }
    return source2;
  }
  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$3.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data = {
  "version": "0.26.1"
};
var VERSION = data.version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional2(validator2, version, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$2 = utils$e;
var buildURL2 = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request(configOrUrl, config) {
  if (typeof configOrUrl === "string") {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }
  config = mergeConfig$1(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional3 = config.transitional;
  if (transitional3 !== void 0) {
    validator.assertOptions(transitional3, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$2.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$2.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$1.prototype[method] = function(url, data2, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  this.promise.then(function(cancel) {
    if (!token._listeners)
      return;
    var i;
    var l2 = token._listeners.length;
    for (i = 0; i < l2; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token,
    cancel
  };
};
var CancelToken_1 = CancelToken;
var spread = function spread2(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var utils$1 = utils$e;
var isAxiosError = function isAxiosError2(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
};
var utils = utils$e;
var bind2 = bind$2;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind2(Axios.prototype.request, context);
  utils.extend(instance, Axios.prototype, context);
  utils.extend(instance, context);
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig2(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
const DEFAULT_URL = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json"
};
const getSuggestions = async (suggestion) => {
  var _a, _b;
  const url = (_a = suggestion.url) != null ? _a : DEFAULT_URL;
  const count = (_b = suggestion.count) != null ? _b : 10;
  let payload = {
    query: suggestion.query,
    count
  };
  if (suggestion.toBound) {
    payload = __spreadProps(__spreadValues({}, payload), {
      to_bound: { value: suggestion.toBound }
    });
  }
  if (suggestion.fromBound) {
    payload = __spreadProps(__spreadValues({}, payload), {
      from_bound: { value: suggestion.fromBound }
    });
  }
  if (suggestion.locationOptions) {
    payload = __spreadProps(__spreadValues({}, payload), {
      language: suggestion.locationOptions.language,
      locations: suggestion.locationOptions.locations,
      locations_boost: suggestion.locationOptions.locationsBoost
    });
  }
  const config = {
    headers: __spreadProps(__spreadValues({}, DEFAULT_HEADERS), {
      Authorization: `Token ${suggestion.token}`
    })
  };
  const {
    data: { suggestions }
  } = await axios.post(url, payload, config);
  return suggestions;
};
const useSuggestions = (props, emit) => {
  const queryProxy = computed({
    get: () => props.modelValue,
    set: (value) => emit("update:modelValue", value)
  });
  const suggestionProxy = computed({
    get: () => props.suggestion,
    set: (value) => emit("update:suggestion", value)
  });
  const inputFocused = ref(false);
  const suggestionsVisible = ref(true);
  const suggestionIndex = ref(-1);
  const suggestionList = ref([]);
  const suggestionItem = ref(void 0);
  const fetchSuggestions = async (count) => {
    try {
      const request2 = {
        token: props.token,
        query: queryProxy.value,
        url: props.url,
        toBound: props.toBound,
        fromBound: props.fromBound,
        locationOptions: props.locationOptions,
        count
      };
      return getSuggestions(request2);
    } catch (error) {
      emit("handleError", error);
      return new Promise((resolve) => {
        resolve([]);
      });
    }
  };
  const fetchWithDebounce = vueDebounce_min.exports.debounce(async () => {
    suggestionList.value = await fetchSuggestions();
  }, props.debounceWait);
  watch(queryProxy, async () => {
    fetchWithDebounce();
  });
  const resetSuggestions = () => {
    if (props.disabled) {
      return;
    }
    suggestionsVisible.value = false;
    suggestionIndex.value = -1;
  };
  const selectSuggestion = (index) => {
    if (props.disabled) {
      return;
    }
    if (suggestionList.value.length >= index - 1) {
      queryProxy.value = suggestionList.value[index].value;
      suggestionItem.value = suggestionList.value[index];
      suggestionProxy.value = suggestionList.value[index];
    }
  };
  const onInputChange = () => {
    if (props.disabled) {
      return;
    }
    suggestionsVisible.value = true;
  };
  const limitUp = computed(() => suggestionIndex.value < suggestionList.value.length - 1);
  const limitDown = computed(() => suggestionIndex.value >= 0);
  const withinTheBoundaries = computed(() => limitDown.value && limitUp.value);
  const onKeyPress = (keyboardEvent, keyEvent) => {
    if (props.disabled) {
      return;
    }
    keyboardEvent.preventDefault();
    if (keyEvent === KeyEvent.Enter) {
      if (withinTheBoundaries.value) {
        selectSuggestion(suggestionIndex.value);
        resetSuggestions();
      }
    }
    if (keyEvent === KeyEvent.Esc) {
      suggestionsVisible.value = false;
    }
    if (keyEvent === KeyEvent.Up) {
      if (limitDown.value) {
        suggestionIndex.value -= 1;
      }
    }
    if (keyEvent === KeyEvent.Down) {
      if (limitUp.value) {
        suggestionIndex.value += 1;
      }
    }
  };
  const onInputFocus = () => {
    if (props.disabled) {
      return;
    }
    inputFocused.value = true;
  };
  const onInputBlur = () => {
    var _a;
    if (props.disabled) {
      return;
    }
    if (props.autocomplete) {
      queryProxy.value = suggestionItem.value ? (_a = suggestionItem.value) == null ? void 0 : _a.value : "";
    }
    inputFocused.value = false;
  };
  const onSuggestionClick = (index) => {
    if (props.disabled) {
      return;
    }
    selectSuggestion(index);
    resetSuggestions();
  };
  return {
    queryProxy,
    suggestionProxy,
    inputFocused,
    suggestionsVisible,
    suggestionIndex,
    suggestionList,
    onInputChange,
    onKeyPress,
    onInputFocus,
    onInputBlur,
    onSuggestionClick
  };
};
var index_css_vue_type_style_index_0_src_3d6871d2_lang = "";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main = defineComponent({
  name: "VueDadata",
  components: {
    WordHighlighter: l
  },
  props: {
    token: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    },
    suggestion: {
      type: Object,
      default: () => void 0
    },
    placeholder: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: void 0
    },
    debounceWait: {
      type: String || Number,
      default: "1000ms"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fromBound: {
      type: String,
      default: void 0
    },
    toBound: {
      type: String,
      default: void 0
    },
    inputName: {
      type: String,
      default: "vue-dadata-input"
    },
    locationOptions: {
      type: Object,
      default: void 0
    },
    classes: {
      type: Object,
      default: () => DEFAULT_CLASSES
    },
    highlightOptions: {
      type: Object,
      default: () => DEFAULT_HIGHLIGHT_OPTIONS
    },
    autocomplete: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "update:suggestion", "handleError"],
  setup(props, { emit }) {
    const proxyClasses = useClasses(props.classes);
    const proxyHighlightOptions = useHighlightOptions(props.highlightOptions);
    const {
      queryProxy,
      suggestionProxy,
      inputFocused,
      suggestionsVisible,
      suggestionIndex,
      suggestionList,
      onInputChange,
      onKeyPress,
      onInputFocus,
      onInputBlur,
      onSuggestionClick
    } = useSuggestions(props, emit);
    return {
      KeyEvent,
      queryProxy,
      suggestionProxy,
      inputFocused,
      suggestionsVisible,
      suggestionList,
      proxyClasses,
      proxyHighlightOptions,
      suggestionIndex,
      onInputChange,
      onKeyPress,
      onInputFocus,
      onInputBlur,
      onSuggestionClick
    };
  }
});
const _hoisted_1 = ["name", "disabled", "placeholder"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_word_highlighter = resolveComponent("word-highlighter");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.proxyClasses.container)
  }, [
    createElementVNode("div", {
      class: normalizeClass(_ctx.proxyClasses.search)
    }, [
      withDirectives(createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.queryProxy = $event),
        type: "text",
        name: _ctx.inputName,
        class: normalizeClass(_ctx.proxyClasses.input),
        disabled: _ctx.disabled,
        placeholder: _ctx.placeholder,
        onInput: _cache[1] || (_cache[1] = (...args) => _ctx.onInputChange && _ctx.onInputChange(...args)),
        onKeyup: [
          _cache[2] || (_cache[2] = withKeys(($event) => _ctx.onKeyPress($event, _ctx.KeyEvent.Enter), ["enter"])),
          _cache[3] || (_cache[3] = withKeys(($event) => _ctx.onKeyPress($event, _ctx.KeyEvent.Esc), ["esc"])),
          _cache[4] || (_cache[4] = withKeys(($event) => _ctx.onKeyPress($event, _ctx.KeyEvent.Up), ["up"])),
          _cache[5] || (_cache[5] = withKeys(($event) => _ctx.onKeyPress($event, _ctx.KeyEvent.Down), ["down"]))
        ],
        onFocus: _cache[6] || (_cache[6] = (...args) => _ctx.onInputFocus && _ctx.onInputFocus(...args)),
        onBlur: _cache[7] || (_cache[7] = (...args) => _ctx.onInputBlur && _ctx.onInputBlur(...args))
      }, null, 42, _hoisted_1), [
        [vModelText, _ctx.queryProxy]
      ])
    ], 2),
    _ctx.inputFocused && _ctx.suggestionsVisible && !_ctx.disabled ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(_ctx.proxyClasses.suggestions)
    }, [
      renderSlot(_ctx.$slots, "suggestions", {
        suggestionList: _ctx.suggestionList,
        suggestionIndex: _ctx.suggestionIndex,
        query: _ctx.queryProxy,
        suggestion: _ctx.suggestionProxy
      }, () => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.suggestionList, (suggestionItemList, suggestionIndexList) => {
          return openBlock(), createBlock(_component_word_highlighter, mergeProps({
            key: `suggestion_${suggestionIndexList}`
          }, _ctx.proxyHighlightOptions, {
            "wrapper-class": _ctx.proxyClasses.suggestionItem,
            class: suggestionIndexList === _ctx.suggestionIndex ? _ctx.proxyClasses.suggestionCurrentItem : "",
            query: _ctx.queryProxy,
            "text-to-highlight": suggestionItemList.value,
            onMousedown: ($event) => _ctx.onSuggestionClick(suggestionIndexList)
          }), null, 16, ["wrapper-class", "class", "query", "text-to-highlight", "onMousedown"]);
        }), 128))
      ])
    ], 2)) : createCommentVNode("", true)
  ], 2);
}
var VueDadata = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { BOUNDS, DEFAULT_CLASSES, DEFAULT_HIGHLIGHT_OPTIONS, KeyEvent, VueDadata, getSuggestions };
